
import { Component, Getter, namespace, Vue } from 'bits/vue'
import { SurfaceFilter } from 'enums'
import OzDropdownButton, {
  OzDropdownButtonColorScheme,
  OzDropdownButtonSizePreset,
} from 'library/v4/components/OzDropdownButton.vue'

const postFilterStore = namespace('postFilter')

@Component({
  components: {
    OzDropdownButton,
  },
})
export default class SurfaceFilterDropdownButton extends Vue {
  OzDropdownButtonSizePreset = OzDropdownButtonSizePreset
  OzDropdownButtonColorScheme = OzDropdownButtonColorScheme

  @Getter backgroundLuminance!: 'light' | 'dark'
  @Getter colorScheme!: 'light' | 'dark'
  @Getter dir!: 'ltr' | 'rtl'
  @Getter isMap!: boolean
  @postFilterStore.Getter filter!: SurfaceFilter
  @postFilterStore.Getter isCustomFilter!: boolean
  @postFilterStore.Getter xFilterPopover!: boolean
  @postFilterStore.Action showFilterPopover!: () => void

  get dropdownButtonText(): string {
    switch (this.filter) {
      case SurfaceFilter.Published:
        return this.__('Published')
      case SurfaceFilter.Submitted:
        return this.__('Submitted')
      default:
        return this.__('All')
    }
  }
}
